module.exports = __webpack_public_path__ + "img/empty.4401f8b5.svg";